import { render, staticRenderFns } from "./MetaInfo.vue?vue&type=template&id=025f0134&scoped=true"
import script from "./MetaInfo.vue?vue&type=script&lang=js"
export * from "./MetaInfo.vue?vue&type=script&lang=js"
import style0 from "./MetaInfo.vue?vue&type=style&index=0&id=025f0134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f0134",
  null
  
)

export default component.exports